export const SITE_MODULATORS_CARD_FRENCH_LOCALE = {
  title: "Modulateurs installés sur le site",
};
